var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { addClassToElement, removeClassFromElement } from 'fk-cp-common-components/utils/domUtils';
var BaseDrawer = /** @class */ (function (_super) {
    __extends(BaseDrawer, _super);
    function BaseDrawer(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollHeight = 0;
        _this.artificialScrollApplied = false;
        _this.lockBodyScroll = function () {
            _this.scrollHeight = _this.getScrollTop();
            document.body.style.top = -_this.scrollHeight + "px";
            //To fix scroll up issue inside drawer. In Android and iOS, when body is not scrolled at all the scroll up inside the drawer is also blocking.
            if (_this.scrollHeight === 0) {
                window.scrollTo(0, 1);
                _this.artificialScrollApplied = true;
                _this.scrollHeight = 1;
            }
            addClassToElement(document.body, _this.noScrollClassName);
        };
        _this.unlockBodyScroll = function () {
            removeClassFromElement(document.body, _this.noScrollClassName);
            //To fix scroll lock issue in ios and android.
            var restorePosition = _this.artificialScrollApplied ? 0 : _this.scrollHeight;
            window.scrollTo(0, restorePosition);
            _this.artificialScrollApplied = false;
            document.body.style.top = null;
        };
        _this.getScrollTop = function () {
            // Modern browsers || Modern IE || Old IE 6,7,8
            return window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        };
        _this.scrollHeight = 0;
        _this.noScrollClassName = props.noScrollClassName;
        _this.artificialScrollApplied = false;
        return _this;
    }
    BaseDrawer.prototype.componentWillUnmount = function () {
        this.unlockBodyScroll();
    };
    return BaseDrawer;
}(React.Component));
export default BaseDrawer;
